export const getFfJsonValue =
	<T>(flagName: string, defaultValue: T, map?: (x: object) => T) =>
	(featureFlags: object): T => {
		const maybeValue = featureFlags[flagName];
		if (typeof maybeValue === 'string') {
			try {
				const value = JSON.parse(maybeValue);
				return map ? map(value) : value;
			} catch (err) {
				if (
					process.env.CLOUD_ENV === 'staging' ||
					process.env.CLOUD_ENV === 'hello' ||
					process.env.CLOUD_ENV === 'branch'
				) {
					// eslint-disable-next-line no-console
					console.error(`Failed to parse ff "${flagName}"`, err);
				}
				return defaultValue;
			}
		}
		return defaultValue;
	};

// This is a hard-coded list of macros which need to use the legacy macro browser approach
// See: https://hello.atlassian.net/wiki/spaces/ETEMP/pages/3693499448/Manually+opted+out+macros+using+FF
export const getOptedOutMacros = (): string[] => {
	const optedOutMacros = [
		'create-from-template',
		'auibutton',
		'cfm-progress-bar-hyperlink-step',
		'decisionreport',
		'viewpdf',
		'viewdoc',
		'viewxls',
		'viewppt',
		'cqlmacro1',
		'detailssummary',
		'contentbylabel',
	];
	return optedOutMacros;
};
